module.exports = __webpack_public_path__ + "img/GalaxyS10+.17d0effa.jpg";